import { Props } from '@/pages/register/Models/address';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Fetch as FetchValidate } from '../sagas/plate/validate';
import { Fetch as FetchUser } from '../sagas/register/createUser';
import { ExtractItems } from '../sagas/extract';
import { RechargesItems } from '../sagas/extract/recharges';
import { FormattedDebts, FormattedTickets } from '@/utils/transform';
/**
 * Types
 */
export interface TypesType {
    SEND_PIN_REGISTER_DEVICE: string;
    VALIDATE_PIN_REGISTER_DEVICE: string;
    SEND_PIN_REGISTER: string;
    VALIDATE_PIN_REGISTER: string;
    SEND_PIN_AVULSO: string;
    VALIDATE_PIN_AVULSO: string;
    SEND_PIN_FORGOT: string;
    VALIDATE_PIN_FORGOT: string;
    CLEAR_CUSTOMER: string;
    SEARCH_ADDRESS: string;
    AUTH: string;
    REFRESH: string;
    SEND_MESSAGE: string;
    GET_DATA: string;
    VALIDATE_PLATE: string;
    REQUEST_BRANDS: string;
    REQUEST_CATEGORIES: string;
    REQUEST_MODELS: string;
    REQUEST_YEARS: string;
    CREATE_USER: string;
    CREATE_CREDENTIALS: string;
    CHANGE_PASSWORD: string;
    REQUEST_EXTRACT: string;
    REQUEST_RECHARGES: string;
    CHANGE_PASSWORD_AUTH: string;
    UPDATE_DATA: string;
    GET_CUSTOMER_DATA: string;
    DELETE_VEHICLE: string;
    GET_VEHICLES: string;
    REQUEST_VALUES: string;
    RECHARGE_PIX: string;
    RECHARGE_SAVED_CARD: string;
    RECHARGE_CARD: string;
    CHANGE_PAYMENT_METHOD: string;
    CREATE_VEHICLE: string;
    REQUEST_TICKETS: string;
    REQUEST_INVOICE: string;
}

export const Types: TypesType = {
    SEND_PIN_REGISTER_DEVICE: 'customer/sendPinRegisterDevice',
    VALIDATE_PIN_REGISTER_DEVICE: 'customer/validatePinRegisterDevice',
    SEND_PIN_REGISTER: 'customer/sendPinRegister',
    VALIDATE_PIN_REGISTER: 'customer/validatePinRegister',
    SEND_PIN_AVULSO: 'customer/sendPinAvulso',
    VALIDATE_PIN_AVULSO: 'customer/validatePinAvulso',
    SEND_PIN_FORGOT: 'customer/sendPinForgot',
    VALIDATE_PIN_FORGOT: 'customer/validatePinForgot',
    CLEAR_CUSTOMER: 'customer/clearCustomer',
    SEARCH_ADDRESS: 'customer/searchAddress',
    AUTH: 'customer/auth',
    REFRESH: 'customer/refresh',
    SEND_MESSAGE: 'customer/sendMessage',
    GET_DATA: 'customer/getData',
    VALIDATE_PLATE: 'customer/validatePlate',
    REQUEST_BRANDS: 'customer/requestBrands',
    REQUEST_CATEGORIES: 'customer/requestCategories',
    REQUEST_MODELS: 'customer/requestModels',
    REQUEST_YEARS: 'customer/requestYears',
    CREATE_USER: 'customer/createUser',
    CREATE_CREDENTIALS: 'customer/createCredentials',
    CHANGE_PASSWORD: 'customer/changePassword',
    REQUEST_EXTRACT: 'customer/requestExtract',
    REQUEST_RECHARGES: 'customer/requestRecharges',
    CHANGE_PASSWORD_AUTH: 'customer/changePasswordAuth',
    UPDATE_DATA: 'customer/updateData',
    GET_CUSTOMER_DATA: 'customer/getCustomerData',
    DELETE_VEHICLE: 'customer/deleteVehicle',
    GET_VEHICLES: 'customer/getVehicles',
    REQUEST_VALUES: 'customer/requestValues',
    RECHARGE_PIX: 'customer/paymentPix',
    RECHARGE_SAVED_CARD: 'customer/paymentSavedCard',
    RECHARGE_CARD: 'customer/paymentCard',
    CHANGE_PAYMENT_METHOD: 'customer/changePaymentMethod',
    CREATE_VEHICLE: 'customer/createVehicle',
    REQUEST_TICKETS: 'customer/requestTickets',
    REQUEST_INVOICE: 'customer/requestInvoice',
}
/**
 * Initial State
 */

export enum PAYMENT_TYPE {
    IS_DEBIT = 'Debito - Conta',
    IS_CARD = 'Cartao - Credito',
    IS_TICKET = '',
}

export enum ID_PAYMENT_TYPE {
    IS_DEBIT = '3',
    IS_CARD = '1',
    IS_TICKET = '2',
    IS_EMPTY = '',
}
interface InitialState {
    [key: string]: string | number | boolean | unknown;
    apiKey?: string;
    isLoading?: boolean;
    isLoadingVehicles?: boolean;
    disablePendingAttemptPaymentModal?: boolean;
    accessToken?: string;
    refreshToken?: string;
    accessTokenTemporary?: string;
    refreshTokenTemporary?: string;
    username?: string;
    selectedVehicles?: string[];
    register?: {
        orderId?: string;
        document?: string;
        phone?: string;
        pin?: string;
        hashCode?: string;
        name?: string;
        email?: string;
        birthdate?: string;
        address?: {
            zipcode?: string;
            streetName?: string;
            neighborhood?: string;
            neighborId?: string;
            city?: string;
            cityId?: string;
            state?: string;
            stateName?: string;
            stateId?: string;
            number?: string;
            complement?: string;
        };
        vehicle?: {
            plate?: string;
            plateCode?: string;
            type?: string;
            model?: string;
            brand?: string;
        };
        password?: string;
        confirmPassword?: string;
    };
    forgot?: {
        document?: string;
        pin?: string;
        hashCode?: string;
        password?: string;
        confirmPassword?: string;
    };
    client?: {
        id?: string;
        document?: string;
        name?: string;
        email?: string;
        birthdate?: string;
        birthday?: string;
        phone?: string;
        homePhone?: string;
        registrationDate?: string;
        addresses: {
            type?: {
                name?: string;
            };
            zipcode: string;
            streetName: string;
            number: string;
            complement: string;
            neighborhood: string;
            city: string;
            state: {
                id: string | null;
                name: string;
            };
            main?: boolean;
        }[];
    };
    account?: {
        balance?: number;
        id?: string;
        idPaymentType?: ID_PAYMENT_TYPE;
        paymentMode?: string;
        card?: {
            id?: string,
            brand?: string,
            cardNumber?: string;
            dueMonth?: string;
            dueYear?: string;
        };
        paymentType?: PAYMENT_TYPE;
    };
    extract?: {
        items?: ExtractItems['items'];
        isLoading?: boolean;
        selectedFilter?: '30' | '60' | '90' | null;
        lastUpdated?: Date;
    };
    vehicles?: {
        plate?: string;
        brand?: string;
        model?: string;
    }[];
    recharges?: {
        items?: RechargesItems['items'];
        isLoading?: boolean;
        selectedFilter?: '30' | '60' | '90' | null;
        lastUpdated?: Date;
    };
    recharge?: {
        mandatory?: null | {
            id: string;
            value: number;
            text: number;
            title: string;
            mandatory: boolean;
        };
        selectedValue?: null | {
            id: string;
            value: number;
            text: number;
            title: string;
            mandatory: boolean;
        };
    };
    tickets?: FormattedTickets[];
    requestId?: string;
    debts?: FormattedDebts[];
    cart?: {
        name: string;
        checked: boolean;
    }[] | null;
}

export type State = InitialState

export const initialState: InitialState = {
    isLoading: false,
    disablePendingAttemptPaymentModal: false,
}

export interface Callback {
    callback: (
        success: boolean,
        errorMessage?: string,
    ) => void;
    callbackLight: (
        success: boolean
    ) => void;
    callbackZipcode: (
        success: boolean,
        address?: Props['address'],
    ) => void;
    callbackVehicles: (
        success: boolean,
        data: null | {
            id: string;
            name: string;
        }[]
    ) => void;
}

export const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        setCustomer(state, action: PayloadAction<InitialState>) {
            Object.keys(action.payload).forEach((item) => {
                state[item] = action.payload[item];
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendPinRegisterDevice(_, __: PayloadAction<{
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePinRegisterDevice(_, __: PayloadAction<{
            pin: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendPinRegister(_, __: PayloadAction<{
            document: string;
            phone?: string;
            email?: string;
            name?: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePinRegister(_, __: PayloadAction<{
            document: string;
            pin: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendPinAvulso(_, __: PayloadAction<{
            plate: string;
            phone?: string;
            email?: string;
            name?: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePinAvulso(_, __: PayloadAction<{
            plate: string;
            pin: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clearCustomer(state: { [key: string]: unknown }) {
            Object.keys(state).forEach((item) => {
                const value = state[item];
                switch (typeof value) {
                    case "string":
                        state[item] = "";
                        break;
                    case "boolean":
                        state[item] = false;
                        break;
                    case "number":
                        state[item] = 0;
                        break;
                    default:
                        state[item] = null;
                }
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        searchAddress(_, __: PayloadAction<{
            zipcode: string;
            callback: Callback['callbackZipcode'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        auth(_, __: PayloadAction<{
            username: string;
            password: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        refresh(_, __: PayloadAction<{
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendMessage(_, __: PayloadAction<{
            name: string;
            email: string;
            message: string;
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getData(_, __: PayloadAction<{
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePlate(_, __: PayloadAction<{
            plate: string;
            document: string;
            pin?: string;
            hashCode?: string;
            callback: FetchValidate['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestBrands(_, __: PayloadAction<{
            type: string;
            callback: Callback['callbackVehicles'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestCategories(_, __: PayloadAction<{
            typeId: string;
            modelId: string;
            brandId: string;
            callback: Callback['callbackVehicles'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestModels(_, __: PayloadAction<{
            type: string;
            brandId: string;
            callback: Callback['callbackVehicles'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestYears(_, __: PayloadAction<{
            modelId: string;
            brandId: string;
            callback: Callback['callbackVehicles'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createUser(_, __: PayloadAction<{
            data: {
                brandName?: string;
                modelName?: string;
            };
            callback: FetchUser['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createCredentials(_, __: PayloadAction<{
            visitorId: string;
            password: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendPinForgot(_, __: PayloadAction<{
            document: string;
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validatePinForgot(_, __: PayloadAction<{
            document: string;
            pin: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        changePassword(_, __: PayloadAction<{
            document: string;
            pin: string;
            hashCode: string;
            newPassword: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestExtract(_, __: PayloadAction<{
            period: '30' | '60' | '90';
            callback: (
                success: boolean,
                items?: ExtractItems['items'],
            ) => void;
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestRecharges(_, __: PayloadAction<{
            period: '30' | '60' | '90';
            callback: (
                success: boolean,
                items?: RechargesItems['items'],
            ) => void;
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        changePasswordAuth(_, __: PayloadAction<{
            password: string;
            newPassword: string;
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateData(_, __: PayloadAction<{
            email: string;
            birthdate: string;
            phone: string;
            homePhone: string;
            address: {
                type: string;
                zipcode: string;
                streetName: string;
                number: string;
                neighborhood: string;
                city: string;
                stateName: string;
                complement: string;
            };
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getCustomerData(_, __: PayloadAction<{
            callback: Callback['callbackLight'];
        } | undefined>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        deleteVehicle(_, __: PayloadAction<{
            plate: string;
            identifier: string;
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getVehicles(_, __: PayloadAction<{
            callback: Callback['callbackLight'];
        } | undefined>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestValues(_, __: PayloadAction<{
            callback: (success: boolean, values?: {
                id: string;
                value: number;
                text: number;
                title: string;
                mandatory: boolean;
            }[]) => void;
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        paymentPix(_, __: PayloadAction<{
            callback: (success: boolean, data?: {
                code?: string;
                image?: string;
                imageType?: string;
                imageWidth?: number;
            }) => void;
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        paymentSavedCard(_, __: PayloadAction<{
            visitorId: string;
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        paymentCard(_, __: PayloadAction<{
            visitorId: string;
            card: {
                number: string;
                name: string;
                expiration: string;
            };
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        changePaymentMethod(_, __: PayloadAction<{
            visitorId: string;
            card: {
                number: string;
                name: string;
                expiration: string;
                autoPayment?: boolean;
            };
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createVehicle(_, __: PayloadAction<{
            visitorId: string;
            vehicleInfos: {
                brandName?: string;
                modelName?: string;
            };
            vehicle: {
                type: string;
                plate: string;
                brand: string;
                model: string;
                plateCode: string;
            };
            callback: Callback['callbackLight'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestTickets(_, __: PayloadAction<{
            callback: Callback['callback'];
        }>) {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        requestInvoice(_, __: PayloadAction<{
            invoiceId: string;
            callback: Callback['callback'];
        }>) {},
    }
});
export const { 
    setCustomer, 
    sendPinRegisterDevice, 
    validatePinRegisterDevice,
    sendPinRegister,
    validatePinRegister,
    sendPinAvulso,
    validatePinAvulso,
    clearCustomer,
    searchAddress,
    auth,
    refresh,
    sendMessage,
    getData,
    validatePlate,
    requestBrands,
    requestCategories,
    requestModels,
    requestYears,
    createUser,
    createCredentials,
    sendPinForgot,
    validatePinForgot,
    changePassword,
    requestExtract,
    requestRecharges,
    changePasswordAuth,
    updateData,
    getCustomerData,
    deleteVehicle,
    getVehicles,
    requestValues,
    paymentPix,
    paymentSavedCard,
    paymentCard,
    changePaymentMethod,
    createVehicle,
    requestTickets,
    requestInvoice,
} = customerSlice.actions;

export default function customerReducer(
    state: InitialState = initialState,
    action: PayloadAction<unknown>
  ): InitialState {
    return customerSlice.reducer(state, action);
  }
